module.exports = __webpack_public_path__ + "static/media/IMG_4513a.eab3f60d.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/roraima/IMG_4513a.JPG
// module id = 120
// module chunks = 0